import type {
  ProvenanceDetailResponse,
  ProvenanceListResponse,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function getContentProvenance(contentRef: string): Promise<ProvenanceListResponse> {
  return httpClient.get<ProvenanceListResponse>(
    `/protected/content/${encodeURIComponent(contentRef)}/provenance`
  );
}

export async function getProvenanceDetail(provenanceCode: string): Promise<ProvenanceDetailResponse> {
  return httpClient.get<ProvenanceDetailResponse>(
    `/protected/provenance/${encodeURIComponent(provenanceCode)}`
  );
}
